export const InputStatusColors = {
    DEFAULT: '#D7D7D7',
    GREEN: '#45AE06',
    RED: '#C40606'
};

export const InputStatusBGColors = {
    DEFAULT: '#FFFDF4',
    GREEN: '#FFFDF4',
    RED: '#FFF3F3',
    DISABLED: '#F7F7F7'
};

export const EmptyGuid = '00000000-0000-0000-0000-000000000000';

export const CampaignGoalEnum = {
    BUDGET: 'budget',
    WEEKLYBUDGET: 'weeklyBudget',
    SPOTS: 'spotsPerWeek',
    TARGETREACH: 'targetReach',
    BASEREACH: 'baseReach',
    TARGETOTH: 'weeklyTargetOTH',
    BASEOTH: 'weeklyBaseOTH',
    OVERALLTARGETOTH: 'overallTargetOTH',
    OVERALLBASEOTH: 'overallBaseOTH',
    TARGET: 'targetImpacts',
    BASE: 'baseImpacts'
};

export const WorkflowTypes = {
    ACCOUNT: 0,
    CAMPAIGNQUOTE: 1,
    CAMPAIGNDISCOUNT: 2,
    VALUEPOT: 3,
    SANDPPRECAMPAIGNBOOKING: 4,
    CAMPAIGNCANCELLATION: 7,
    SANDPPOSTCAMPAIGNBOOKING: 8,
    PRECAMPAIGNBOOKING: 9,
    SPOTTYPEDISTRIBUTION: 10
};

export const DealTypes = {
    BASE: 1,
    CLIENT: 2,
    AGENCY: 3
};

export const AttachmentType = {
    NOTE: { id: 0, name: 'Note' },
    ATTACHMENT: { id: 1, name: 'Attachment' }
};

export const DealDiscountPolicy = {
    ADD: { id: 1, text: 'Add to Total Delivery' },
    DEDUCT: { id: 2, text: 'Deduct from Total Spend' }
};

export const BusinessTypes = {
    AIRTIME: { name: 'Airtime', text: 'Airtime', canCreate: true },
    SANDP: { name: 'SAndP', text: 'S&P', canCreate: true },
    OFFAIRS: { name: 'OffAirs', text: 'Off-Airs', canCreate: true },
    // PACKAGE: { name: 'Package', text: 'Package', canCreate: true },
    DIGITAL: { name: 'Digital', text: 'Digital', canCreate: true },
    AIRTIMEBURST: { name: 'AirtimeBurst', text: 'Airtime Burst', canCreate: false }
};

export const FileDownloadTypes = {
    CSVFile: { name: 'csvFile', text: 'CSV format' },
    PDFFile: { name: 'pdfFile', text: 'PDF format' }
};

export const GetBusinessTypeByText = (text) => {
    const businessTypeKey = Object.keys(BusinessTypes).find((key) => BusinessTypes[key].text === text);
    return BusinessTypes[businessTypeKey];
};

export const GetBusinessTypeByName = async (name) => {
    const businessTypeKey = Object.keys(BusinessTypes).find((key) => BusinessTypes[key].name === name);
    return BusinessTypes[businessTypeKey];
};

export const CampaignHistoryEvent = {
    CAMPAIGN: { id: 0, name: 'Campaign' },
    DISCOUNT_APPROVAL: { id: 1, name: ' Discount approval' },
    AIRTIME_RESERVATION: { id: 2, name: 'Airtime reservation' },
    VALUE_POT_APPROVAL: { id: 3, name: 'Value Pot approval' },
    BOOKING_APPROVAL: { id: 4, name: 'Pre-booking approval' },
    POST_BOOKING_APPROVAL: { id: 5, name: 'Post-booking approval' },
    CANCEL_CAMPAIGN_APPROVAL: { id: 6, name: 'Cancel campaign approval' }
};

export const GetCampaignHistoryEventNameById = (id) => {
    const eventKey = Object.keys(CampaignHistoryEvent).find((key) => CampaignHistoryEvent[key].id === id);

    return eventKey ? CampaignHistoryEvent[eventKey].name : '';
};

export const CampaignHistoryAction = {
    BOOKED: { id: 0, name: 'Booked' },
    RENEGOTIATED: { id: 1, name: 'Renegotiated' },
    QUALIFIED_OUT: { id: 2, name: 'Qualified out' },
    REQUESTED: { id: 3, name: 'Requested' },
    APPROVED: { id: 4, name: 'Approved' },
    DENIED: { id: 5, name: 'Denied' },
    CREATED: { id: 6, name: 'Created' },
    EXPIRED: { id: 7, name: 'Expired' },
    CANCELLED: { id: 8, name: 'Cancelled' },
    DELETED: { id: 9, name: 'Deleted' },
    RESTORED: { id: 10, name: 'Restored' },
    UPDATED: { id: 11, name: 'Updated' },
};

export const GetCampaignHistoryActionNameById = (id) => {
    const actionKey = Object.keys(CampaignHistoryAction).find((key) => CampaignHistoryAction[key].id === id);

    return actionKey ? CampaignHistoryAction[actionKey].name : '';
};

export const DefaultCostings = {
    None: -1,
    Cpt: 1,
    Spot: 2,
    PreferCpt: 3,
    PreferSpot: 4
};

export const ApprovalStatusEnum = {
    NOT_REQUESTED: 'Not Requested',
    AWAITING_APPROVAL: 'Awaiting Approval',
    APPROVED: 'Approved',
    REJECTED: 'Rejected'
};

export const BookingApprovalStatusEnum = {
    AWAITING_APPROVAL: 0,
    APPROVED: 1,
    REJECTED: 2,
    PREAPPROVED: 3
};

export const ApprovalActionTypes = {
    APPROVE: 0,
    DENY: 1
};

export const GridStatusBGColors = {
    HIGHLIGHTED: '#DCFFFF',
    SELECTED: '#FDF1D6',
    STRIPE: '#F7F7F7',
    NOSTRIPE: '#FFFFFF'
};

export const QuoteStatusEnum = {
    SPECULATIVE: 0,
    PLANNED: 1,
    BOOKED: 2,
    REPLACED: 3,
    CANCELLED: 4,
    RESERVED: 5,
    RELEASED: 6,
    EXPIRED: 7,
    INVALID: 8
};

export const OffairAllocatedType = {
    MONTHLY: 1,
    DAYS: 2
};

export const OffairStatuses = {
    DRAFT: 1,
    QUOTED: 2,
    BOOKED: 3,
    BILLED: 4,
    CANCELLED: 5
};
